import { render, staticRenderFns } from "./project-switcher.vue?vue&type=template&id=43a2439d&scoped=true&"
import script from "./project-switcher.vue?vue&type=script&lang=js&"
export * from "./project-switcher.vue?vue&type=script&lang=js&"
import style0 from "./project-switcher.vue?vue&type=style&index=0&id=43a2439d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a2439d",
  null
  
)

export default component.exports